module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_7016.db474007.png";